import React, { useEffect } from "react";
import { DescriptionColorEnum, IDescription } from "@/components/YhBox/Types";
import { Button, message } from "antd";
import { YhBox } from "@/components/YhBox";
import { BillDataTable } from "./DataTable";
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/FmsResourceAuthEnum";
import { useBillInternalModel } from "../billInternalModel";
import { PageHeader } from "./PageHeader";
import { labelsType } from "@/views/cash/pay/cashPayModel";
import { orgService } from "@/views/base/org/orgService";
import { beService } from "@/views/base/be/beService";
import { DictCodeEnmu } from "@/types/FmsDictEnums";
import useGlobalModel from "@/model/globalModel";

export const BillInternal = () => {
    const {
        setBeDs,
        billSummaryData,
        setOrgDs,
        selectedData,
        setWriteoffDrawerVisible,
        loadData,
        setPayMethodLabels,
        loadCustomer,
    } = useBillInternalModel();
    const { getSelectedDict } = useGlobalModel(() => []);



    useEffect(() => {
        let obj: labelsType = {}
        orgService.orgTreeDs({}).then(ds => setOrgDs(ds))
        beService.beDs({}).then(ds => setBeDs(ds))
        getSelectedDict(DictCodeEnmu.SETTLE_TYPE).forEach(item => {
            obj[item.value] = item.label
        })
        setPayMethodLabels(obj);
        loadCustomer()
        loadData({ pageNum: 1 }).then()
    }, []);

    const desc: IDescription[] = [
        {
            label: "账单总额",
            value: billSummaryData?.totalBillAmount?.toFixed(2) ?? '0.00',
            color: DescriptionColorEnum.green
        },
        {
            label: "已核销总额",
            value: billSummaryData?.totalWriteoffAmount?.toFixed(2) ?? '0.00',
            color: DescriptionColorEnum.green
        },
        {
            label: "未核销总额",
            value: billSummaryData?.totalUnWriteoffAmount?.toFixed(2) ?? '0.00',
            color: DescriptionColorEnum.red
        },

    ]


    return (
        <>
            <PageHeader />
            <YhBox title={"账单列表"} descriptions={desc} >
                <BillDataTable />
            </YhBox>
        </>
    )
}
